<template>
  <div class="lib__form__main" data-cy="attachment-component">
    <ValidationObserver ref="validator" slim>
      <div class="lib__form__main__content">
        <header class="lib__form__main__header">
          <h2 class="lib__h2" v-html="$t('attachmentStep.title')"></h2>
        </header>

        <p>{{ $t('attachmentStep.subTitle') }}</p>

        <ul class="lib__list">
          <li v-html="$t('attachmentStep.futurEquipmentLocationPlan')"></li>
        </ul>

        <div>
          <white-check-box :text="`${$t('attachmentStep.no')}<small>${$t('attachmentStep.noDescription')}</small>`" data-cy="no-attachment" radio v-model="noChecked"></white-check-box>
        </div>

        <div>
          <white-check-box :text="`${$t('attachmentStep.yes')}<small>${$t('attachmentStep.yesDescription')}</small>`" data-cy="with-attachment" radio v-model="yesChecked">
            <WorksInputFile :filesInfo="locationFilesInfo" :label="`${$t('attachmentStep.futurEquipmentLocationPlan')} : `" :request-id="requestId" accept="jpg|jpeg|png|gif|pdf|doc|docx|xls|xlsx|zip|eml|msg|dwg" directory="synergrid-connection" v-if="yesChecked"></WorksInputFile>
            <Feedback v-if="fileInError" level="danger" simple icon>
              <p>{{ $t('attachmentStep.fileInError') }}</p>
            </Feedback>
          </white-check-box>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import Step from '@/components/steps/Step'
import { State, Mutation } from 'vuex-class'
import { FileInfo } from '@ores/vue-library'
import { AttachmentState } from '@/store/synergrid-connection/attachment/types'
import WorksInputFile from '@/components/inputs/Files/WorksInputFile.vue'

@Component({
  name: 'attachment-step',
  components: {
    WorksInputFile
  }
})
export default class AttachmentStep extends Step {
  //#region [Data]
  @State('requestId', { namespace: 'synergridConnection' })
  public readonly requestId!: string

  @State('attachDocuments', { namespace: 'synergridConnection/attachment' })
  public attachDocumentsState!: boolean
  @State('locationFilesInfo', { namespace: 'synergridConnection/attachment' })
  public locationFilesInfoState!: FileInfo[]

  public attachDocuments: boolean = false
  public locationFilesInfo: FileInfo[] = []
  //#endregion

  //#region [Computed]
  public get fileInError(): boolean {
    return this.locationFilesInfo.some((v) => v.error !== null)
  }

  public get yesChecked(): boolean {
    return this.attachDocuments !== null && !!this.attachDocuments
  }

  public set yesChecked(newVal: boolean) {
    this.attachDocuments = newVal
  }

  public get noChecked(): boolean {
    return this.attachDocuments !== null && !this.attachDocuments
  }

  public set noChecked(newVal: boolean) {
    this.attachDocuments = !newVal
  }
  //#endregion

  //#region [Mutation]
  @Mutation('STORE', { namespace: 'synergridConnection/attachment' })
  private store!: (index: AttachmentState) => void
  //#endregion

  //#region [Method]
  public mounted() {
    this.setIsBack(false)
    this.attachDocuments = this.attachDocumentsState
    this.locationFilesInfo = this.locationFilesInfoState
  }

  public async save(next: boolean, isValid: boolean): Promise<boolean> {
    if (isValid) {
      this.$appInsights.trackEvent('WR_SC_StepAttachment_Validated', {
        Segment: 'WR_SC',
        WebRef: this.requestId
      })
    }

    this.store({
      locationFilesInfo: this.locationFilesInfo.filter((a) => a.error === null),
      attachDocuments: this.attachDocuments
    })
    return Promise.resolve(true)
  }
  //#endregion
}
</script>